<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout row align-center>
      <v-flex xs12 md4 offset-md4>
        <v-card>
        <v-card-title
          class="headline secondary white--text"
          primary-title
        >
          Reset password
        </v-card-title>
          <v-card-text>
            <v-flex xs12>
              <v-text-field
                v-model="email"
                name="email"
                type="email"
                :label="$t('auth.email')"
                prepend-icon="mail"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="password"
                name="password"
                :append-icon="hidePassword ? 'visibility' : 'visibility_off'"
                :type="hidePassword ? 'password' : 'text'"
                :label="$t('auth.password')"
                @click:append="hidePassword = !hidePassword"
                prepend-icon="lock"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="passwordConfirmation"
                name="password_confirmation"
                :append-icon="hideConfirmPassword ? 'visibility' : 'visibility_off'"
                :type="hideConfirmPassword ? 'password' : 'text'"
                :label="$t('auth.confirmPassword')"
                prepend-icon="lock"
                @click:append="hideConfirmPassword = !hideConfirmPassword"
                @keyup.enter="reset"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 text-xs-right>
              <v-btn
                color="accent"
                type="submit"
                @click="resetPassword"
              >
                {{ $t("auth.reset") }}
              </v-btn>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'reset',
  data() {
    return {
      email: null,
      password: null,
      passwordConfirmation: null,
      hidePassword: true,
      hideConfirmPassword: true,
      apiUrl: window.api_url,
    };
  },
  methods: {
    resetPassword() {
      const vm = this;

      axios.post(`${this.apiUrl}api/password/reset`, {
        email: this.email,
        password: this.password,
        password_confirmation: this.passwordConfirmation,
        token: this.$route.params.token,
      })
        .then((response) => {
          vm.$toasted.show(response.data.message, { duration: 3000, singleton: true, type: 'success' });
          vm.$router.push('/');
        })
        .catch((error) => {
          vm.$toasted.show(error.response.data.message, { duration: 3000, singleton: true, type: 'error' });
          vm.$router.push('/');
        });
    },
  },
};
</script>

<style scoped>

</style>
